const CardState = {
  cards: {data: []}
};

export default CardState;
